'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_ClientAppDocument(lineage, data) {
  this.XQ = null;
  this.oi = null;
  this.XQ = lineage;
  this.oi = data;
}
export { $c_Lapp_data_ClientAppDocument as $c_Lapp_data_ClientAppDocument };
$p = $c_Lapp_data_ClientAppDocument.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_ClientAppDocument;
/** @constructor */
function $h_Lapp_data_ClientAppDocument() {
}
export { $h_Lapp_data_ClientAppDocument as $h_Lapp_data_ClientAppDocument };
$h_Lapp_data_ClientAppDocument.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_ClientAppDocument)) {
    var x = this.XQ;
    var x$2 = x$0.XQ;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.oi;
      var x$4 = x$0.oi;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "ClientAppDocument";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.XQ;
  }
  if ((n === 1)) {
    return this.oi;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "lineage";
  }
  if ((n === 1)) {
    return "data";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_ClientAppDocument(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jg)));
}
export { $isArrayOf_Lapp_data_ClientAppDocument as $isArrayOf_Lapp_data_ClientAppDocument };
var $d_Lapp_data_ClientAppDocument = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_ClientAppDocument, "app.data.ClientAppDocument", ({
  jg: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_ClientAppDocument as $d_Lapp_data_ClientAppDocument };
//# sourceMappingURL=app.data.-Client-App-Document.js.map
